import { render, staticRenderFns } from "./m_esg026.vue?vue&type=template&id=d87afef4&"
import script from "./m_esg026.vue?vue&type=script&lang=js&"
export * from "./m_esg026.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports